const ElasticAdapter = {
  encodeFilters: (queryParams: any, allowedFacets: string[] = []) =>
    allowedFacets.reduce(
      (stacked, facet) =>
        queryParams[facet]
          ? {
              ...stacked,
              [facet]: Array.isArray(queryParams[facet])
                ? queryParams[facet]
                : [queryParams[facet]],
            }
          : stacked,
      {},
    ),
  sanitizeParams: (data: any) => {
    const { filters, customFilters, needsUpdate, needsPush, ...params } = data;

    return {
      ...params,
      ...filters,
    };
  },
};

export default ElasticAdapter;
